import { render, staticRenderFns } from "./AFechax.vue?vue&type=template&id=3681d56a"
import script from "./AFechax.vue?vue&type=script&lang=js"
export * from "./AFechax.vue?vue&type=script&lang=js"
import style0 from "./AFechax.vue?vue&type=style&index=0&id=3681d56a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports